import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';
import { BoostIcon } from 'src/svgs/BoostIcon';
import { BoostIconLight } from 'src/svgs/BoostIconLight';
import { PosIconProps } from 'src/svgs/SvgWrapper';

export const BoostIconDisplay = (
  props: Omit<PosIconProps, 'viewBox' | 'fill' | 'stroke'> & {
    isSelected?: boolean;
    inactive?: boolean;
  }
) => {
  const { isDarkMode } = useSiteTheme();

  return props.isSelected || isDarkMode ? (
    <BoostIconLight
      {...props}
      inactive={props.inactive}
      activeFill={
        props.isSelected
          ? isDarkMode
            ? vars.color.surfacePrimary
            : vars.color.iconPrimaryInverted
          : isDarkMode
            ? vars.color.textPrimaryV2
            : undefined
      }
    />
  ) : (
    <BoostIcon {...props} inactive={props.inactive} />
  );
};
